<template>
    <div class="container">
        <div class="head_bg">
            <common-head></common-head>
            <div class="head_content">
                <img src="../assets/images/img_john.png" alt="">
                <div class="head_content_text">
                    <div>“</div>
                    <div>
                        <p>人人有爱，公益助学</p>
                        <p>致力于传播人人有爱的文化愿景，用更多的爱暖更多的心，更多的心聚更多的爱。同时提倡公益助学，为中国教育事业的发展贡献力量。</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg_c_w p_t_36">
            <h1>麦乐会理事</h1>
            <p>2013年1月1日，徐俊先生创立启动了麦乐会。麦乐会是独立的公益组织，严格按照国家法律及《章程》进行管理。理事会是最高决策机构，麦乐会理事会在原有28人的基础上,2018年又重新招募十三位新的理事，且规范了麦乐会的组织职能。目前在职理事22人，包括 John Susan Bella Pascale Alice Cherry Lucio Gemini Stone Cora Leo Xixi Janna Blue Maple.hc Lisa Bart Peter.Wan Dorae Kyrie Emily Sherry</p>
            <div class="member_list">
                <img src="../assets/images/mlh_ls1.png" alt="">
                <img src="../assets/images/mlh_ls2.png" alt="">
                <img src="../assets/images/mlh_ls3.png" alt="">
                <img src="../assets/images/mlh_ls4.png" alt="">
                <img src="../assets/images/mlh_ls5.png" alt="">
                <img src="../assets/images/mlh_ls6.png" alt="">
                <img src="../assets/images/mlh_ls7.png" alt="">
                <img src="../assets/images/mlh_ls8.png" alt="">
                <div class="bg_c_o"></div>
                <div class="bg_c_o"></div>
                <div class="bg_c_o"></div>
                <div class="bg_c_o"></div>
                <div></div>
            </div>

        </div>

        <div class="bg_c_w">
            <div class="news_title">
                <h1>新闻动态</h1>
                <span @click="handleMore" v-show="isShow">{{showMore ?'查看更多':'收起'}}</span>
            </div>
            <div class="news_list_items" @click="handleDetails(item.id)" v-for="(item,index) in newsList" :key="index">
                <img :src="item.Img" alt="">
                <div>
                    <h2>{{item.Name}}</h2>
                    <p>{{item.Summary}}</p>
                    <p>{{item.CreateTime}}</p>
                </div>
            </div>
        </div>

        <div class="bg_c_w">
            <h1>公益足迹</h1>
            <van-swipe :autoplay="3000" :show-indicators="false">
                <van-swipe-item>
                    <div class="swipe_items">
                        <img src="../assets/images/mlh_honor_1.png" alt="">
                        <img src="../assets/images/mlh_honor_2.png" alt="">
                        <img src="../assets/images/mlh_honor_3.png" alt="">
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="swipe_items">
                        <img src="../assets/images/mlh_honor_4.png" alt="">
                        <img src="../assets/images/mlh_honor_5.png" alt="">
                        <img src="../assets/images/mlh_honor_6.png" alt="">
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="swipe_items">
                        <img src="../assets/images/mlh_honor_7.png" alt="">
                        <img src="../assets/images/mlh_honor_8.png" alt="">
                        <img src="../assets/images/mlh_honor_9.png" alt="">
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
        <common-footer></common-footer>
    </div>
</template>

<script>
import commonHead from '../components/common-head.vue'
import commonFooter from '../components/common-footer.vue'
export default {
    data() {
        return {
            newsList: [],
            newsMoreList: [],
            isShow:false,
            showMore: false
        }
    },
    components: {
        commonHead,
        commonFooter
    },
    created() {
        const { getData } = this
        getData()
    },
    methods: {
        getData() {
            this.$http.get("site/mlh").then(response => {
                response.d.forEach(res => {
                    res.id = res.Link.includes('?') && res.Link.split('?')[1].split('=')[1]
                });
                this.isShow = response.d.length>2?true:false;
                if (response.d.length > 2) {
                    this.showMore = true
                    this.newsList = response.d.slice(0, 2);
                    this.newsMoreList = response.d.slice(2);
                } else {
                    this.showMore = false
                    this.newsList = response.d
                }

            });
        },
        handleMore() {
            const { newsList, newsMoreList } = this;
            if (this.showMore) {
                this.showMore = false
                this.newsList = newsList.concat(newsMoreList)
            } else {
                this.showMore = true
                this.newsList = newsList.slice(0, 2)
            }
        },
        handleDetails(id) {
            this.$router.push({ name: 'Details', query: { id } });
        }
    }
}
</script>

<style lang="less" scoped>
.head_bg {
    background-image: url("../assets/images/banner_mlh.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    & .head_content {
        position: relative;
        height: 155px;
        & img {
            width: 100px;
            height: 135px;
            position: absolute;
            left: 0px;
            bottom: 0;
        }
        & .head_content_text {
            color: #ffffff;
            animation: head_content_text_animation 2s;
            & > div:nth-child(1) {
                width: 22px;
                height: 49.5px;
                opacity: 0.64;
                font-family: Arial-BoldMT;
                font-size: 44px;
                position: absolute;
                top: 42px;
                left: 88px;
            }
            & > div:nth-child(2) {
                position: absolute;
                top: 56.5px;
                left: 118px;
                letter-spacing: 0;
                line-height: 20px;
                & > p:first-child {
                    font-size: 16px;
                }
                & > p:last-child {
                    font-size: 12px;
                }
            }
        }
    }
}

.p_t_36 {
    padding-top: 36px !important;
}

.bg_c_w {
    padding: 0 20px 46px;
    & > h1 {
        padding-bottom: 24px;
    }
    & > p {
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        line-height: 20px;
    }

    & > .news_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 24px;
        & > span {
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
        }
    }
    & .news_list_items:last-child {
        margin-bottom: 0;
    }
    & .news_list_items {
        display: flex;
        margin-bottom: 16px;
        & > img {
            width: 140px;
            height: 79px;
        }
        & > div {
            flex: 1;
            padding-left: 12px;
            & > h2 {
                width: 182.5px;
                font-size: 14px;
                color: #000000;
                letter-spacing: 0;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                padding-bottom: 4px;
            }

            & > p:nth-child(2) {
                width: 182.5px;
                height: 32.5px;
                font-size: 12px;
                color: #666666;
                letter-spacing: 0;
                line-height: 16px;
                padding-bottom: 7.5px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            & > p:nth-child(3) {
                font-size: 11px;
                color: #999999;
                letter-spacing: 0;
            }
        }
    }

    & .member_list {
        width: 100%;
        height: 150px;
        position: relative;
        & img {
            position: absolute;
            border-radius: 50%;
        }
        & img:nth-child(1) {
            width: 30px;
            height: 31px;
            top: 53px;
            left: 0;
        }
        & img:nth-child(2) {
            width: 42px;
            height: 43.5px;
            top: 75.5px;
            left: 47.5px;
        }
        & img:nth-child(3) {
            width: 58.5px;
            height: 61px;
            top: 24px;
            left: 123.5px;
        }
        & img:nth-child(4) {
            width: 30px;
            height: 31px;
            top: 91.5px;
            left: 174.5px;
        }
        & img:nth-child(5) {
            width: 37.5px;
            height: 38.5px;
            top: 39px;
            left: 206.5px;
        }
        & img:nth-child(6) {
            width: 21.5px;
            height: 22px;
            top: 58.5px;
            left: 274.5px;
        }
        & img:nth-child(7) {
            width: 26.1px;
            height: 28px;
            top: 98.5px;
            left: 244px;
        }
        & img:nth-child(8) {
            width: 42px;
            height: 43.5px;
            top: 98.5px;
            left: 109.5px;
        }

        & div:nth-child(9) {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            opacity: 0.11;
            position: absolute;
            top: 106px;
            left: 24px;
        }
        & div:nth-child(10) {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            opacity: 0.34;
            position: absolute;
            top: 64px;
            left: 81.5px;
        }
        & div:nth-child(11) {
            width: 11.5px;
            height: 11.5px;
            border-radius: 50%;
            position: absolute;
            top: 112px;
            left: 217px;
        }
        & div:nth-child(12) {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            opacity: 0.34;
            position: absolute;
            top: 64px;
            left: 327.5px;
        }
        & div:nth-child(13) {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            position: absolute;
            top: 99px;
            left: 289.5px;
            background-color: #d8d8d8;
        }
    }

    & .swipe_items {
        display: flex;
        & img {
            width: 105px;
            height: 95px;
            display: block;
        }
        & .member_list {
            width: 100%;
            height: 166px;
            position: relative;

            & img {
                position: absolute;
                border-radius: 50%;
            }
        }
        & .swipe_items {
            display: flex;
            & img {
                width: 105px;
                height: 95px;
                display: block;
            }
            & > img:nth-child(1),
            & > img:nth-child(2) {
                margin-right: 10px;
            }
        }
    }
}

@keyframes head_content_text_animation {
    0% {
        opacity: 0;
        transform: translateY(-56.5px);
    }
    100% {
        opacity: 0.64;
        transform: translateY(0px);
    }
}
</style>